import { Mission } from "./Mission";
import { Vission } from "./Vission";

export function Purpose({ mission, vission}) {
  return(
    <div id="proposito">
      <section className="hero is-small is-success">
        <div className="hero-body">
          <h2 className="subtitle is-2 bf-sub-title">Glorioso Propósito</h2>
        </div>
      </section>

      <div className="columns">
        <div className="column m-0 p-0">
          <Mission mission={mission}/>
        </div>
        <div className="column m-0 p-0">
          <Vission vission={vission}/>
        </div>
      </div>
    </div>
  );
}